<template>
	<div class="divide-y-2 divide-gray-200">
		<!-- quantity -->
		<div class="p-6 grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-6 items-end">
			<div>
				<ui-input-group
					v-model="form.qty.mt"
					field="qty.mt"
					label="Quantity in metric tons"
					suffix="t"
					:form="form"
					:required="true"
				></ui-input-group>
			</div>
			<offer-edit-qty-tolerance :form="form" />
			<ui-check-group
				class="col-span-2 flex pb-2 mb-px"
				v-model="form.qty.partial_ok"
				field="qty.partial_ok"
				:form="form"
				:required="true"
				label="Partial quantity possible"
				tooltip-text="Target quantity can also be fulfilled by partial quantities."
			>
			</ui-check-group>
		</div>

		<!-- price -->
		<offer-edit-price
			class="p-6"
			:form="form"
			:activeFutures="activeFutures"
			:is-price-required="isPriceRequired"
		/>

		<!-- Location -->
		<offer-edit-location class="p-6" :form="form" />
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
	},
	computed: {
		isPriceRequired() {
			return this.form.trade == "BUY";
		},
	},
};
</script>
